import { render, staticRenderFns } from "./FormDatagridRow.vue?vue&type=template&id=908ebfc0&scoped=true&"
import script from "./FormDatagridRow.vue?vue&type=script&lang=js&"
export * from "./FormDatagridRow.vue?vue&type=script&lang=js&"
import style0 from "./FormDatagridRow.vue?vue&type=style&index=0&id=908ebfc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ebfc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu})
